import {Entity} from "../domain/entities/entity";
import {VIEW_COMPONENT} from "../symbols";

export function viewComponent<TEntity extends Entity, TPropertyEntity extends Entity>(
    viewComponentName: string,
    settings: Record<string, any> | null = null,
    propertyType?: TPropertyEntity
) {
    return (target: TEntity, propertyKey: Extract<keyof TEntity, string | symbol>): void => {
        Reflect.defineMetadata(
            VIEW_COMPONENT,
            {
                viewComponentName,
                propertyType,
                settings
            },
            target.constructor,
            propertyKey
        );
    }
}